export default __webpack_public_path__ + "static/18_31-4a3cb5c0447a1b437108478bd04f9038.png";